import styled from "@emotion/styled";


const Image = styled.img`

`


const Container = {
    marginLeft: -0,
    }

   const img ={
    width: '100%',
    height: '100%',
   } 

const SC = {
    Container,
    img
   
}

export default SC;


